



























import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import store from "@/store/index";
import { NavigationMenu } from "../../types/enum/OrderEnum";

@Component
export default class NewOrderModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Mutation("handleShowNewOrderModal") handleShowNewOrderModal!: Function;
  @Getter("incomingOrderCount") incomingOrderCount!: number;
  @Getter("refundingOrderCount") refundingOrderCount!: number;
  public get show(): boolean {
    if (this.newOrderAndRefundCount === 0) {
      return false;
    } else return this.value;
  }

  public set show(v: boolean) {
    if (this.newOrderAndRefundCount === 0) {
      return;
    } else this.handleShowNewOrderModal(v);
  }

  public get newOrderAndRefundCount(): number {
    return this.incomingOrderCount + this.refundingOrderCount;
  }

  @Mutation("handleTabIndex") handleTabIndex!: Function;
  public get index(): NavigationMenu {
    return NavigationMenu.Orders;
  }

  toOrderPage() {
    this.handleShowNewOrderModal(false);
    this.handleTabIndex(NavigationMenu.Orders);
    if (this.$route.name !== "Orders") {
      this.$router.push({ name: "Orders" });
    }
  }

  close() {
    this.handleShowNewOrderModal(false);
    // clearInterval(window.orderLoopPalySoundTimer);
  }
}
